import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GraphKnDataService} from '../../services/graph-kn.data.service';
import {MatDialogRef} from '@angular/material/dialog';
import {ContractStepModel} from '../../../../models/contract.model';
import { KN_STEPS_STYLES_MAP, TStepTypeCode } from '../../styles/nodes-styles/graph-node-contract-step-styling';

@Component({
    selector: 'app-add-step-form',
    templateUrl: './add-step-form.component.html',
    styleUrl: './add-step-form.component.scss'
})
export class AddStepFormComponent {
    public stepModel: Map<TStepTypeCode, { icon: string, color: string, selected: boolean }> = KN_STEPS_STYLES_MAP;
    public newSteps: Map<TStepTypeCode, string[]> = new Map()
    addStepForm: FormGroup
    stepControl = new FormControl([null, {validators: Validators.required}]);

    constructor(
        fb: FormBuilder,
        private dialogRef: MatDialogRef<AddStepFormComponent>,
        private knDataService: GraphKnDataService,
    ) {
        this.addStepForm = fb.group({
            stepCode: this.stepControl,
            stepName: null
        })
        this.stepModel.delete('credit_letter')
        this.stepModel.forEach((el, keyEl) => this.newSteps.set(keyEl, []))
    }

    get stepCode() {
        return this.addStepForm.get('stepCode')
    }

    get stepName() {
        return this.addStepForm.get('stepName')
    }

    changeStep(step: { key: TStepTypeCode, value: { icon: string, color: string, selected: boolean } }) {
        step.value.selected = true
        let newStep = new ContractStepModel();
        let newId = Math.round(Math.random() * 1000) + 'removeNewId';
        this.newSteps.get(step.key)?.push(newId)
        newStep.target_type = step.key
        newStep.name = '';
        newStep.target = {};
        newStep.target.is_verified = false;
        newStep.sort_index = 4;
        if (['payment', 'direct_payment'].includes(step.key)) {
            newStep.payment_data = {
                total: 0,
                payer_guid: 'null',
                recipient_guid: 'null',
            };
        }
        newStep.name = ''
        this.knDataService.subOnNewSteps$.next({step: newStep, id: newId, add: true});
        this.dialogRef.close()
    }

    removeStep(e: Event, stepId: number, stepArr: number[], step: {
        key: TStepTypeCode,
        value: { icon: string, color: string, selected: boolean }
    }) {
        e?.preventDefault()
        e?.stopPropagation()
        stepArr.splice(stepArr.indexOf(stepId), 1)
        step.value.selected = stepArr.length > 0
        this.knDataService.subOnNewSteps$.next({step: null, id: stepId.toString(), add: false});
    }
}
